/* should render this but as a component
  {errors.password && <p>{errors.password.message}</p>}
  */

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import useLocaleErrorMessage from '@/hooks/use-locale-error-message'
import { AlertCircle } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { HStack } from '../Layout/Stacks'

export interface ErrorProps {
  errorSize?: 'sm' | 'md'
  error?: {
    message?: string
  }
}

export default function FormError({ error, errorSize }: ErrorProps) {
  const t = useTranslations('generic')
  const getErrorMessage = useLocaleErrorMessage()
  const message = getErrorMessage(error)

  if (!message) return null

  return (
    <Alert
      variant="destructive"
      className="bg-transparent dark:border-red-400/30 p-2 text-xs"
    >
      <HStack className="gap-2" align="center">
        {errorSize != 'sm' && <AlertCircle className="h-4 w-4 flex-shrink-0" />}
        {errorSize != 'sm' && (
          <AlertTitle className="font-bold my-auto">{t('error')}</AlertTitle>
        )}
        <AlertDescription className="text-xs text-destructive">
          {message}
        </AlertDescription>
      </HStack>
    </Alert>
  )
}
